import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";

export const Footer = () => {
  const navigate = useNavigate();
  const jump = (id) => (e) => { e.preventDefault(); scrollToId(id); };
  return (
    <footer className="va-foot">
      <div className="wrap">
        <div className="footgrid">
          <div>
            <div className="brand" style={{ marginBottom: 10 }}>
              <Logo w={31} h={26} />
              <span className="name" style={{ fontSize: 16 }}>veri<span className="g">Auth</span><span className="d">.ai</span></span>
            </div>
            <div>Verify. Authenticate. Trust every AI process.</div>
            <div style={{ marginTop: 8 }}>Bengaluru, India · <a style={{ color: "var(--green)" }} href="mailto:connect@veriauth.ai">connect@veriauth.ai</a></div>
          </div>
          <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
            <div>
              <div className="kv" style={{ marginBottom: 8 }}>PRODUCT</div>
              <div><a href="/#how" onClick={jump("how")}>How it works</a></div>
              <div><a href="/#api" onClick={jump("api")}>API</a></div>
              <div><a href="/#test" onClick={jump("test")}>Test your AI</a></div>
            </div>
            <div>
              <div className="kv" style={{ marginBottom: 8 }}>WHY</div>
              <div><a href="/#problem" onClick={jump("problem")}>The problem</a></div>
              <div><a href="/#consequences" onClick={jump("consequences")}>Consequences</a></div>
              <div><a href="/#domains" onClick={jump("domains")}>Domains</a></div>
            </div>
          </div>
        </div>
        <div className="disc">
          Sources: RBI FREE-AI Committee Report (13 Aug 2025, advisory); DPDP Act 2023, Schedule &amp; s.33 (statutory
          maxima ₹250 cr / ₹200 cr, per violation, discretionary); EU AI Act high-risk obligations. Regulatory
          references are summarised for orientation and penalty figures are statutory ceilings, not predictions of any
          specific outcome. VeriAuth is not a law firm and this site is not legal advice. © 2026 VeriAuth Technologies
          Pvt. Ltd.
        </div>
      </div>
    </footer>
  );
};
